import type { PaginationParams } from '@space-shell/common/services/types'

import { ViewAsUtils } from '@space-shell/common/utils/viewAs'
import { requester } from '@space-shell/config/request'

import { BundleEndpoints } from './'
import type { Bundles, ProductsBundle } from './'

class BundleService {
  static getBundles = async (slug: string, bundleLimit?: PaginationParams) => {
    const response = await requester.get<Bundles>(BundleEndpoints.bundles(slug), {
      params: {
        ...bundleLimit,
        ...ViewAsUtils.getParams()
      }
    })

    return response.data
  }

  static getProducts = async (bundleId: number, slug: string) => {
    const response = await requester.get<ProductsBundle>(BundleEndpoints.products(bundleId, slug))

    return response.data
  }
}

export default BundleService
